import { useNavigate } from "react-router-dom"

export default function SellerConfirmed({open, setOpen, onConfirm, title, subtitle, buttonTexts, buttonFunctions}) {
    const navigate = useNavigate();
    return (
        open && 

        <div className="energyListing__inner__energyListed-cover">

        <div className="energyListing__inner__energyListed">

<div className="energyListing__inner__energyListed__close">
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.75781 17.2438L12.0008 12.0008L17.2438 17.2438M17.2438 6.75781L11.9998 12.0008L6.75781 6.75781" stroke="#D42620" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</div>
<div className="energyListing__inner__energyListed__title">{title}</div>

<div className="energyListing__inner__energyListed__subtitle">
    {subtitle}
</div>
<div className="energyListing__inner__energyListed__button-group">
<button onClick={buttonFunctions[0]}>{buttonTexts[0]}</button>
<button 
onClick={buttonFunctions[1]}
>{buttonTexts[1]}</button>
</div>

</div>
        </div>
    )
}